import { render, staticRenderFns } from "./OceanShipping.vue?vue&type=template&id=034dcf07&scoped=true&"
import script from "./OceanShipping.vue?vue&type=script&lang=js&"
export * from "./OceanShipping.vue?vue&type=script&lang=js&"
import style0 from "./OceanShipping.vue?vue&type=style&index=0&id=034dcf07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034dcf07",
  null
  
)

export default component.exports